module.exports = __webpack_public_path__ + "img/inProgress.9750393e.svg";